export class TablePage {
        data: any[]
        totalCount: number
}
